export const DropboxIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <circle cx="10" cy="10" r="8.75" fill="#0061FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1875 5.625L4.375 7.27941L7.1875 8.93382L4.375 10.5882L7.1875 12.2426L10 10.5882L12.8125 12.2426L15.625 10.5882L12.8125 8.93382L15.625 7.27941L12.8125 5.625L10 7.27941L7.1875 5.625ZM10 7.27941L12.8125 8.93382L10 10.5882L7.1875 8.93382L10 7.27941Z"
        fill="white"
      />
      <path d="M7.1875 13.3456L10 11.6912L12.8125 13.3456L10 15L7.1875 13.3456Z" fill="white" />
    </svg>
  );
};
